import { CustomNode } from '../../../types';
import { sendEmailIcon } from '../../../icons';

const DEFAULT_ICON = sendEmailIcon;

export const sendEmailConfig: CustomNode = {
  getNodeConfig() {
    return {
      icon: DEFAULT_ICON,
    };
  },
};
